import type { ClientCampaignCollaboration } from '@/api/beatlyApi';

/**
 * True when the influencer has accepted the invite (aligned with CoreCampaignCollaboration.is_activated):
 * API maps invite ACCEPTED to ONGOING (and DONE after payout).
 *
 * Missing or unknown `status` is treated as **not** invite-accepted (strict), so we do not show ambiguous rows.
 */
export function isClientCollaborationInviteAccepted(status: string | undefined): boolean {
  return status === 'ONGOING' || status === 'DONE';
}

/** Omits collaborations that are curation-approved but still awaiting invite acceptance (e.g. INVITED). */
export function filterCampaignCollaborationsInviteAccepted(
  collaborations: ClientCampaignCollaboration[],
): ClientCampaignCollaboration[] {
  return collaborations.filter((c) => isClientCollaborationInviteAccepted(c.status));
}
